import { type ActionItem, type ProjectActionItem } from '@consigli/types';

// Support both ActionItem (meeting-level) and ProjectActionItem (project-level)
export type SupportedItem = ActionItem | ProjectActionItem;

// Column configuration for action items table
export type ActionItemColumn = 'title' | 'person' | 'deadline' | 'topic' | 'status' | 'meeting';

// Group by options (subset of columns that can be grouped)
export type GroupByOption = 'person' | 'topic' | 'deadline' | 'status' | 'meeting';

/**
 * Type guard to check if a SupportedItem is a ProjectActionItem.
 * ProjectActionItem has meetingId directly on the item.
 */
export const isProjectActionItem = (item: SupportedItem): item is ProjectActionItem => {
  return 'meetingId' in item && typeof (item as ProjectActionItem).meetingId === 'string';
};

// Helper to get meetingId from item or props
// ProjectActionItem has meetingId directly on the item, ActionItem needs it passed as prop
export const getMeetingId = (item: SupportedItem, propMeetingId?: string): string => {
  // ProjectActionItem has meetingId directly on the item
  if (isProjectActionItem(item)) {
    return item.meetingId;
  }
  if (propMeetingId) {
    return propMeetingId;
  }
  throw new Error('meetingId is required either in item or as prop');
};
